import CommonBridge from 'common/CommonBridge';
import Url from 'url';
import { UtilLogger } from './UtilLogger';

const noop = () => {};
const errorArray = ['jsError', 'httpError'];
const catchErrorType = ['catchError', 'parseError'];
export const getMakeTime = async () => {
  let makeTime = '';
  try {
    const data = await new Promise((resolve) => {
      CommonBridge.getRNInfo((result) => {
        resolve(result);
      });
    });
    makeTime = data.mstd.maketime;
  } catch (e) {
    makeTime = '20180504210903';
  }
  return makeTime;
};
export const getBundleId = async () => {
  let BundleId = '';
  try {
    const data = await new Promise((resolve) => {
      CommonBridge.getRNInfo((result) => {
        resolve(result);
      });
    });
    const url = data.mstd.url;
    const urlArray = url.split('/');
    const index = urlArray.indexOf('mstd');
    if (index > -1) {
      BundleId = Number(urlArray[index + 1]);
    }
  } catch (e) {
    console.log(e);
  }
  return BundleId;
};
/**
 * 设置catch时触发的函数
 * @param customHandler
 * @param allowedInDevMode
 */
export const setJSExceptionHandler = (customHandler = noop, allowedInDevMode = false) => {
  if (typeof allowedInDevMode !== 'boolean' || typeof customHandler !== 'function') {
    return;
  }
  const allowed = allowedInDevMode ? true : !__DEV__;
  if (allowed) {
    // !!! 关键代码
    // 设置错误处理函数
    global.ErrorUtils.setGlobalHandler(customHandler);
    // 改写 console.error，保证报错能被 ErrorUtils 捕获并调用错误处理函数处理
    console.error = (...args) => {
      const e = {
        stack: '未知错误',
        type: 'catchError',
      };
      let stack = '';
      args.forEach((item) => {
        if (catchErrorType.includes(item)) {
          e.type = item;
        } else {
          stack += parseErrorContent(item);
        }
      });
      if (stack) {
        e.stack = stack;
      }
      global.ErrorUtils.reportError(e);
    };
  }
};

const reportError = async (message) => {
  try {
    const obj = {
      pageUrl: window.location.href,
      statType: 'error',
      platform: 'yp_rn_m',
    };
    const data = {};
    data.pageName = Url.parse(window.location.href, true).pathname || '';
    data.stat_source = 'mstd';
    data.message = (message || '').substr(0, 240);
    obj.statInfo = JSON.stringify(data);
    UtilLogger.uploadError(obj);
  } catch (e) {}
};
const mergeErrors = (() => {
  let errors = [];
  let timeout = null;
  return (errorMessage, scriptURI, lineNumber, columnNumber, errorObj) => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    errors.push([lineNumber, columnNumber, errorMessage]);
    timeout = setTimeout(() => {
      const _errors = errors;
      errors = [];
      console.log(_errors);
      const str = _errors
        .map(
          ([lineNumber, columnNumber, errorMessage]) => `line: ${lineNumber},column: ${columnNumber}; ${errorMessage}`,
        )
        .join(';');
      reportError(str);
    }, 20);
  };
})();
/**
 * web端上报catchError
 */
export const setJSExceptionHandlerWeb = () => {
  console.error = (message, error = '', type = 'catchError') => {
    try {
      if (message.startsWith('Warning')) {
        return;
      }
      const stack = parseErrorContent(message) + parseErrorContent(error);
      reportError(stack);
    } catch (error) {}
  };
  window.onerror = mergeErrors;
  window.onunhandledrejection = (event) => {
    // 不兼容ie
    reportError(event.reason.stack);
  };
};

/**
 * 对错误日志的数据进行处理并上传
 * @param data
 */
export const mergeAndUploadContent = async (data) => {
  try {
    const obj = {
      pageUrl: data.pageUrl,
      statType: 'error',
      esiType: data.type,
      platform: 'rn',
    };
    const { pageUrl } = data;
    data.pageName = Url.parse(pageUrl, true).pathname;
    data.makeTime = await getMakeTime();
    data.bundleId = await getBundleId();
    data.deviceId = CommonBridge.isAndroid() ? CommonBridge.IMEI : CommonBridge.IDFA;
    data.stat_source = 'mstd';
    data.message = (data.message || '').substr(0, 200);
    delete data.pageUrl;
    obj.statInfo = JSON.stringify(data);
    UtilLogger.uploadError(obj);
  } catch (e) {
    console.log('上报 失败：', e);
  }
};

export const errorMessageRun = (e, errorType, cb) => {
  const runRow = errorArray.includes(errorType);
  const message = runRow ? lsErrorStack(e) : e && e.stack;
  return cb && cb(message);
};

function lsErrorStack(e) {
  if (!e || !(e instanceof Error) || !e.stack) {
    return '';
  }

  try {
    const stack = e.stack.toString().split(/\r\n|\n/);
    const frameRE = /:(\d+:\d+)[^\d]*$/;
    while (stack.length) {
      const frame = frameRE.exec(stack.shift());
      if (frame) {
        const position = frame[1].split(':');
        return `${e.toString()}.line: ${position[0]}, column: ${position[1]}`;
      }
    }
    return e.toString();
  } catch (e) {
    return e.toString();
  }
}

function parseErrorContent(error) {
  let e = '';
  if (typeof error === 'string' || typeof error === 'number') {
    e = error;
  } else if (judgeType(error) === '[object Error]') {
    e = error.toString();
  } else if (judgeType(error) === '[object Object]') {
    e = JSON.stringify(error);
  }
  return e;
}

function judgeType(obj) {
  return Object.prototype.toString.call(obj);
}
